<template>
  <div class="titleBar">
    <span />
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '基础信息'
    }
  }
}
</script>

<style lang="less" scoped>
.titleBar {
  display: flex;
  align-items: center;
  color: #17757a;
  padding: 0 0 15px 20px;
  span {
    margin-right: 10px;
    width: 4px;
    height: 20px;
    border-radius: 2px;
    background: #17757a;
  }
}
</style>
